import { useQuery } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { loadKPIChart } from 'scenes/KPI/sources/kpi';

import { chart } from './queryKeyFactory';

export const useLoadKPIChart = ({ enabled, keepPreviousData, ...params }) => {
  const { showWarningMessage, showErrorMessage } = useScreenMessage();

  return useQuery(
    chart(params),
    (_, { signal }) => loadKPIChart(params, { signal }),
    {
      enabled: enabled,
      keepPreviousData: keepPreviousData,
      onSuccess: ({ warnings }) => {
        warnings.length && showWarningMessage(warnings, { multiple: true });
      },
      onError: (e) => {
        showErrorMessage(e.message, {
          multiple: Array.isArray(e.message),
        });
      },
    }
  );
};
